'use strict';

const React = require('react');

const PropTypes = require('prop-types');

// Stores
const ItemStore = require('../../stores/ItemStore.es');

// Helpers
const provideContext = require('fluxible-addons-react/provideContext');
const connectToStores = require('fluxible-addons-react/connectToStores');
const classnames = require('classnames');

const Title = ({ isArt, creationDate, creatorData, title }) => {
    const titleClass = classnames({
        'pdp-sidebar-title-text': true,
        italic: isArt,
    });
    const titleWrapperClass = classnames({
        'pdp-sidebar-title-inner': true,
        'pdp-sidebar-art-title-text': isArt,
    });
    let creatorEl;
    let dateEl;

    if (isArt) {
        if (creationDate) {
            dateEl = (
                <div className="pdp-sidebar-title-year-text">
                    <span className="pdp-sidebar-title-year">{creationDate}</span>
                </div>
            );
        }

        if (creatorData && creatorData.name) {
            creatorEl = <div className="pdp-sidebar-title-creator">{creatorData.name}</div>;
        }
    }

    return (
        <h1 className="pdp-sidebar-title">
            {creatorEl}
            <div className={titleWrapperClass} data-tn="pdp-main-title">
                <div className={titleClass}>{title}</div>
                {dateEl}
            </div>
        </h1>
    );
};

Title.propTypes = {
    isArt: PropTypes.bool.isRequired,
    creationDate: PropTypes.string,
    creatorData: PropTypes.shape({
        name: PropTypes.string,
    }),
    title: PropTypes.string.isRequired,
};

const Connected = provideContext(
    connectToStores(Title, [ItemStore], context => {
        const itemStore = context.getStore(ItemStore);

        return {
            creationDate: itemStore.getFromItemModel('classification.creationDate'),
            creatorData: itemStore.getCreatorData(),
            isArt: itemStore.getIsArt(),
            title: itemStore.getFromItemModel('title'),
        };
    })
);

module.exports = {
    Connected,
    Raw: Title,
};



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Sidebar/Title.jsx